// extracted by mini-css-extract-plugin
export var wrap = "Spinner-module--wrap--3QTQ5";